import { ToolbarItem } from '@ariakit/react/toolbar';
import type { ReactNode } from 'react';

interface Props {
    active?: boolean;
    ariaLabel: string;
    children: ReactNode;
    onClick: () => void;
}

export function GraphToolbarButton({
    active = false,
    ariaLabel,
    children,
    onClick,
}: Props): JSX.Element {
    return (
        <ToolbarItem
            type="button"
            className="data-[active=true]:border-primary inline-flex h-9 w-9 items-center justify-center rounded border border-transparent bg-transparent hover:border-gray-300"
            data-active={active}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </ToolbarItem>
    );
}
